import firebase from 'firebase/compat/app';
import 'firebase/compat/storage'
import online from './status.js';
const storage = online ? firebase.storage() : false;
export default storage;